import 'babel-polyfill';
import 'babel-core/register';
import Vue from 'vue';
import VueMq from 'vue-mq';
import svg4everybody from 'svg4everybody/dist/svg4everybody';
import objectFitImages from 'object-fit-images';
import appInsights from './helpers/appInsights';

import { createApp } from './main';

objectFitImages();
svg4everybody();

//user agent functions
const ua = window.navigator.userAgent;
const breakpoint = window.screen.width < 1024 ? 'small' : 'large';
const sessionStorageExternalId = "externalId";

const init = async () => {
    const { app, router, store } = await createApp(false, () => {}, {});

    Vue.use(VueMq, {
        // Keep the same as in the CSS
        breakpoints: {
            xSmall: 480,
            small: 720,
            medium: 1024,
            large: 1200,
            xLarge: 1440,
        },
        defaultBreakpoint: breakpoint,
    });

    // check if user is using a mobile device
    if (
        ua.match(/Android/i) ||
        ua.match(/webOS/i) ||
        ua.match(/iPhone/i) ||
        ua.match(/iPad/i) ||
        ua.match(/BlackBerry/i) ||
        ua.match(/Windows Phone/i)
    ) {
        Vue.prototype.$isMobile = true;
    } else {
        Vue.prototype.$isMobile = false;
    }

    if (window.__INITIAL_STATE__) {
        store.replaceState(window.__INITIAL_STATE__);
    }
    let firstRun = window.__INITIAL_STATE__ && true;

    router.onReady(async () => {
        // Add router hook for handling asyncData.
        // Doing it after initial route is resolved so that we don't double-fetch
        // the data that we already have. Using router.beforeResolve() so that all
        // async components are resolved.
        const matched = router.getMatchedComponents();
        let registerAsyncData = [];
        if (!firstRun) {
            matched.map(Component => {
                const recursive = component => {
                    if (component.asyncData)
                        registerAsyncData.push(component.asyncData);
                    if (component.components) {
                        Object.keys(component.components).forEach(key => {
                            recursive(component.components[key]);
                        });
                    }
                };
                recursive(Component);
            });
            await Promise.all(
                registerAsyncData.map(promiseCallback => {
                    if (typeof promiseCallback === 'function') {
                        return promiseCallback({
                            store,
                            route: router.currentRoute,
                        });
                    }
                    return Promise.resolve();
                })
            );
        }

        const currentRoute = router.currentRoute;
        var externalId = currentRoute.query.extId ? currentRoute.query.extId : currentRoute.query.extid;
        if (externalId) {
            if (typeof window !== 'undefined') {
                sessionStorage.setItem(sessionStorageExternalId, externalId);

                let query = Object.assign({}, currentRoute.query);
                delete query.extId;
                delete query.extid;              

                router.replace({ query: query });
            }   
        }


        firstRun = false;
        router.beforeResolve(async (to, from, next) => {
            const matched = router.getMatchedComponents(to);
            const prevMatched = router.getMatchedComponents(from);

            let diffed = false;
            const activated = matched.filter((c, i) => {
                return diffed || (diffed = prevMatched[i] !== c);
            });
            if (!activated.length) {
                return next();
            }
            try {
                // start loading indicator
                await Promise.all(
                    activated.map(c => {
                        if (c.asyncData) {
                            return c.asyncData({
                                store,
                                route: to,
                            });
                        }
                        return Promise.resolve();
                    })
                );
            } catch (e) {
                return next();
            }
            // stop loading indicator
            return next();
        });

        router.afterEach((to, from) => {
            appInsights.trackPageView({ name: to.name, uri: to.fullPath });
          });    

        app.$mount('#app');
    });
};
init();



// WEBPACK FOOTER //
// ./src/client-entry.js